import { ArrowUp, ArrowDown } from "@semo/icons";
import { formatWon } from "../calc";

/**
 * 변동량 배지 — 증가는 초록 ▲, 감소는 빨강 ▼ + 변화 금액.
 * value가 0이면 아무것도 렌더하지 않습니다.
 */
export function DeltaBadge({ value }: { value: number }) {
  if (!value) return null;
  const up = value > 0;
  return (
    <span
      className={`ml-1 inline-flex items-center gap-0.5 align-middle text-2xs font-medium tabular-nums ${
        up ? "text-emerald-600" : "text-red-500"
      }`}
    >
      {up ? <ArrowUp className="h-3 w-3" /> : <ArrowDown className="h-3 w-3" />}
      {formatWon(Math.abs(value))}
    </span>
  );
}
